import get from 'lodash/get';
import entries from 'lodash/entries';

/**
 *
 * @param {unknown} value
 * @returns {Boolean}
 */
export const isArrayFilled = (value) => {
  if (value == null) return false;
  if (!Array.isArray(value)) return false;
  return value.length > 0;
};

/**
 *
 * @param {boolean | string | Record<string, Record<string, string[]>> | string[]} newValue
 * @param {boolean | string | Record<string, Record<string, string[]>> | string[]} previousValue
 * @return {boolean}
 */
export const isUpgrading = (newValue, previousValue) => {
  if (newValue === false || newValue == null) {
    return false;
  }

  if (Array.isArray(newValue)) {
    if (isArrayFilled(previousValue)) {
      // return false as long as previous value is filled
      return false;
    }
    return isArrayFilled(newValue);
  }

  switch (typeof newValue) {
    case 'boolean': {
      return newValue !== previousValue;
    }
    case 'string': {
      // return false as long as previous value is filled
      // This cover cases where previousValue is not falsey such as:
      // - ""
      // - undefined / null
      return !previousValue;
    }
    case 'object': {
      const hasUpgrade = !!entries(newValue)
        .find(([agreementCode, agreement]) => {
          const clauses = entries(agreement);
          if (clauses.length === 0) return false;

          return !!clauses.find(([clauseCode, clauseValue]) => {
            const previousClauseValue = get(previousValue, [agreementCode, clauseCode]);
            return isUpgrading(clauseValue, previousClauseValue);
          });
        })
      ;

      return hasUpgrade;
    }
    default:
      return false;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/submissionValueHelper.js